import { IconButton, InputAdornment } from "@mui/material";
import Iconify from "src/components/Iconify";
import { RHFTextField } from "src/components/hook-form";

type CustomerRelatedFieldsProps = {
  showPassword: boolean;
  includePasswordField: boolean;
  includeBusinessNameField: boolean;
  disableEmailField: boolean;
  setShowPassword: (flag: boolean) => void;
  hideEmailField?: boolean;
  isInvitationAcceptace?: boolean;
  isExistingUser?: boolean;
};

export default function CustomerRelatedFields({
  showPassword,
  includePasswordField,
  includeBusinessNameField,
  setShowPassword,
  disableEmailField,
  hideEmailField,
  isExistingUser,
}: CustomerRelatedFieldsProps) {

  return (<>
    {!hideEmailField && (
      <RHFTextField name="email" type="email" size='medium' label="Email" disabled={disableEmailField}/>
    )}
    {!isExistingUser && (
      <RHFTextField name="firstName" label="First name" size='medium' />
    )}
    {includeBusinessNameField &&
      <RHFTextField name="businessName" label="Business name" size='medium' />
    }
    {includePasswordField &&
      <RHFTextField
        name="password"
        label="Password"
        size='medium'
        type={showPassword ? 'text' : 'password'}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton edge="end" onClick={() => setShowPassword(!showPassword)}>
                <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    }
  </>)

}
